export const buildAuthHeaders = (token) => (
  typeof token === 'string' && token.length > 0
    ? { Authorization: `Bearer ${token}` }
    : {}
);

export const isValidUserPayload = (user) => (
  user !== null
  && typeof user === 'object'
  && !Array.isArray(user)
  && typeof user.user_id === 'string'
  && user.user_id.length > 0
  && typeof user.email === 'string'
  && user.email.length > 0
);

export const fetchCurrentUser = async ({ apiUrl, token, fetchImpl = fetch }) => {
  const response = await fetchImpl(`${apiUrl}/api/auth/me`, {
    credentials: 'include',
    headers: buildAuthHeaders(token),
  });

  if (!response.ok) return null;

  const user = await response.json();
  return isValidUserPayload(user) ? user : null;
};
